import React from "react";
import styles from "./styles/Warning.module.css";
import { useLanguage } from "../LanguageContext";

function Warning() {
    const { t } = useLanguage();
    const paragraphs = t("warning.paragraphs");

    return (
        <div className={styles.warning}>
            <h1>{t("warning.title")}</h1>
            {paragraphs.map((text, index) => (
                <p key={index}>{text}</p>
            ))}
        </div>
    );
}

export default Warning;
